import React, { useContext, useState } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import Spinner from "../Misc/Spinner";

export default function PaymentButton({ buttonText = null, classes = null }) {
  const {
    checkoutStepValid,
    endpoints,
    order,
    strings,
    setErrors,
  } = useContext(CarOrderingContext)

  const [disabled, setDisabled] = useState(false)

  const orderDeposit = order.security_deposit ?? 0
  let toPaymentLabel = orderDeposit <= 0 ? strings.footer.toPaymentFree : strings.footer.toPayment

  if (buttonText !== null) {
    toPaymentLabel = buttonText
  }

  const submitPurchase = () => {
    if (!checkoutStepValid) {
      return
    }

    setErrors({}) // Clear errors

    if (disabled) {
      return
    }

    setDisabled(true)

    const handledOrder = {
      ...order,
      action: 'ncol_register_order',
      configuration: { car: order.configuration.car, options: [] }
    }

    Object.values(order.configuration.settings).forEach(setting => {
      setting.forEach(option => handledOrder.configuration.options.push(option.id))
    })

    jQuery.ajax({
      'url': endpoints.ajax,
      'method': 'POST',
      'data': {
        'action': 'ncol_register_order',
        ...handledOrder,
      },
    })
      .done(data => {
        if (data.success === true) {
          window.location.href = data.data.accept_url
        } else {
          setDisabled(false)
          setErrors(data.data.errors)
        }
      })
      .fail(error => {
        setDisabled(false)
      })
  }

  return (
    <a
      className={classes}
      role='button'
      onClick={submitPurchase}
      id='payment'
      data-disabled={disabled}
      data-valid={checkoutStepValid}
    >
      {disabled ? <Spinner/> : toPaymentLabel}
    </a>
  )
}
